import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { GetPricesParams } from '../../../../common/api/clients/gateway.api';
import { queries } from '../../../../common/api/queryKeys/queries';

interface UseSchedulePriceCompareProps extends GetPricesParams {}

export const usePriceCompare = (props: UseSchedulePriceCompareProps) => {
    return useQuery({
        ...queries.priceCompare.items(props),
        placeholderData: keepPreviousData,
        staleTime: Infinity,
    });
};
